export type TImageDimensions = {
  width: number;
  height: number;
};

const readImageDimensionsFromSource = (source: string): Promise<TImageDimensions> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';

    image.onload = () => {
      resolve({ width: image.naturalWidth, height: image.naturalHeight });
    };

    image.onerror = () => {
      reject(new Error('unable to read image dimensions'));
    };

    image.src = source;
  });

/**
 * Reads the natural pixel dimensions of an image file in the browser.
 */
export const readImageDimensions = (file: File): Promise<TImageDimensions> => {
  const objectUrl = URL.createObjectURL(file);

  return readImageDimensionsFromSource(objectUrl).finally(() => {
    URL.revokeObjectURL(objectUrl);
  });
};

/**
 * Reads the natural pixel dimensions of an image from a URL (blob, data, or remote).
 */
export const readImageDimensionsFromUrl = (url: string): Promise<TImageDimensions> =>
  readImageDimensionsFromSource(url);
